import { render, staticRenderFns } from "./ObrasServicos.vue?vue&type=template&id=41927c7d&"
import script from "./ObrasServicos.vue?vue&type=script&lang=js&"
export * from "./ObrasServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports